import React, { Component } from 'react'
import { Redirect, withRouter } from 'react-router-dom'
import Loading from '../../pages/Loading'
import {
  APPLICATION_ID_QUERY_PARAMETER,
  APPLICATION_LINE_ID_QUERY_PARAMETER,
  containsOffers,
  getOfferApplicationId,
  getOfferApplicationLineId,
  getOfferStaticInfoCache,
  offersStaticInfoCache, removeAllOfferSessionProperties,
  setOffersId
} from '../../../helpers/offer'
import { getOfferDetails } from '../../../services/vu'
import Error from '../../pages/Error'
import { getConfiguration } from '../../../helpers/configuration'
import {
  COURSE_ID_QUERY_PARAMETER,
  getCourseCode, removeAllCourseSessionProperties
} from '../../../helpers/course'
import {
  containsQueryParameter,
  containsQueryParameters,
  getQueryParameters
} from '../../../helpers/sessionProperties'
import { getAttributeCourseStaticInfo } from '../../../helpers/enrolment'

class PreOfferChecker extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: !containsOffers(),
      loadedOffers: containsOffers() &&
       !(containsQueryParameter(this.props.location.search, COURSE_ID_QUERY_PARAMETER, true) || containsQueryParameter(this.props.location.search, APPLICATION_ID_QUERY_PARAMETER, true) || containsQueryParameter(this.props.location.search, APPLICATION_LINE_ID_QUERY_PARAMETER, true)),
      hasNoOffers: false,
      multipleOffers: false,
      redirect:
        (containsQueryParameter(
          this.props.location.search,
          APPLICATION_ID_QUERY_PARAMETER, true
        ) &&
          containsQueryParameter(
            this.props.location.search,
            APPLICATION_LINE_ID_QUERY_PARAMETER, true
          )) ||
        containsQueryParameter(
          this.props.location.search,
          COURSE_ID_QUERY_PARAMETER
        )
    }
  }

  componentDidMount() {
    if (!this.state.loadedOffers) {
      if (containsQueryParameter(this.props.location.search, COURSE_ID_QUERY_PARAMETER, true) || containsQueryParameter(this.props.location.search, APPLICATION_ID_QUERY_PARAMETER, true) || containsQueryParameter(this.props.location.search, APPLICATION_LINE_ID_QUERY_PARAMETER, true)) {
        removeAllCourseSessionProperties();
        removeAllOfferSessionProperties();
      }
      const courseCode = getCourseCode(this.props.location.search)

      const offerApplicationId = getOfferApplicationId(
        this.props.location.search
      )
      const offerApplicationLineId = getOfferApplicationLineId(
        this.props.location.search
      )

      if (offerApplicationId || offerApplicationLineId || courseCode) {
        getOfferDetails(offerApplicationId, offerApplicationLineId, courseCode)
          .then(offers => {
            setOffersId(offerApplicationId, offerApplicationLineId, courseCode)
            let filterOffers = offers.filter(
              offer => offer.courseStage === 'OFF' && offer.courseSSP === getAttributeCourseStaticInfo('courseSSPNo')
            )
            offersStaticInfoCache(filterOffers)
            if (containsOffers()) {
              this.stopLoading({
                loadedOffers: true
              })
            } else {
              this.stopLoading({
                hasNoOffers: true
              })
            }
          })
          .catch(reason => {
            this.stopLoading({
              error: true
            })
          })
      } else {
        this.stopLoading({
          missingQueryParameters: true
        })
      }
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.redirect) {
      let queryParameters = getQueryParameters(this.props.location.search)

      if (
        !containsQueryParameters(
          queryParameters,
          APPLICATION_ID_QUERY_PARAMETER
        ) &&
        !containsQueryParameters(
          queryParameters,
          APPLICATION_LINE_ID_QUERY_PARAMETER
        )
      ) {
        this.stopLoading({
          redirect: false
        })
      }
    }
    let offer = getOfferStaticInfoCache()
    if (offer && offer.length >= 2) {
      this.stopLoading({
        multipleOffers: true
      })
    }
  }

  stopLoading = (newState = {}) => {
    this.setState({
      loading: false,
      ...newState
    })
  }

  render() {
    if (this.state.loading) {
      return <Loading />
    }
    if (this.state.loadedOffers && this.state.multipleOffers) {
      return (
        <Error
          title="Multiple Available Offers"
          description={
            <p>
              It looks like there is an issue with the offer’s enrolment URL.
            </p>
          }
          longDescription={
            <span>
              If you're a commencing student, please wait for an email with the
              correct URL. If you're a continuing student, please navigate to{' '}
              <a href="https://myvu.edu.au">MyVU</a> and click on My Course from
              the dropdown menu, then Enrol Now on the My Course page.
            </span>
          }
        />
      )
    }

    if (!this.state.loadedOffers && this.state.missingQueryParameters) {
      return (
        <Error
          title="Invalid Offer"
          description={
            <p>
              It looks like there is an issue with the offer’s enrolment URL.
            </p>
          }
          longDescription={
            <span>
              If you're a commencing student, please wait for an email with the
              correct URL. If you're a continuing student, please navigate to{' '}
              <a href="https://myvu.edu.au">MyVU</a> and click on My Course from
              the dropdown menu, then Enrol Now on the My Course page.
            </span>
          }
        />
      )
    }

    if (this.state.error) {
      return (
        <Error
          title="We are unable to access your offer"
          description={<p>There is an error with your offer.</p>}
          longDescription={
            <span>
              For assistance, please contact{' '}
              <a href="https://www.vu.edu.au/contact-us/vuhq-student-service-centres">
                VUHQ
              </a>
              ‌.
            </span>
          }
          hideContactInfo="true"
        />
      )
    }

    if (this.state.hasNoOffers) {
      return <Redirect to={{ pathname: getConfiguration('baseUrl') + '/' }} />
    }

    if (this.state.redirect) {
      return (
        <Redirect to={{ pathname: getConfiguration('baseUrl') + '/offer' }} />
      )
    }

    return this.props.children
  }
}

export default withRouter(PreOfferChecker)
